// extracted by mini-css-extract-plugin
module.exports = {"button-container":"UserGroupDetails__button-container___mvjWq"};